module.exports = __webpack_public_path__ + "img/img-ordena.2924e175.png";